import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconService, ToastService } from '@isophi/core-ui';
import { Material } from '@isophi/teachers-shared';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSpinnerService } from 'ngx-spinner';

import { environment } from '../../../../../environments/environment';
import { MaterialService } from '../../services/material.service';

@Component({
    selector: 'app-material-set',
    templateUrl: './material-set.component.html',
    styleUrls: ['./material-set.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MaterialSetComponent {
  @Input() material: Material;

  materialServer: string;

  constructor(
    public icons: IconService,
    protected materialService: MaterialService,
    protected spinner: NgxSpinnerService,
    protected toastr: ToastService,
    protected translocoService: TranslocoService
  ) {
    this.materialServer = environment.materialServer;
  }

  downloadAll(uuid): void {
    this.spinner.show();

    this.materialService.downloadAllMaterials(uuid).subscribe({
      error: () => {
        this.toastr.warning(this.translocoService.translate('support/downloadMaterialWarn'));
        this.spinner.hide();
      },
      complete: () => this.spinner.hide()
    })
  }
}
